// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__ME3ZM","modal":"Modal_modal__DyjOU","slide-down":"Modal_slide-down__T2TeN"};